import { mdbContainer, mdbRow, mdbCol, mdbCardBody, mdbCard } from "mdbvue";
import { mapActions } from "vuex";
import Btn from "../../../../core/Button";
import Popup from "../../../../core/Popup";
import Swal from "sweetalert2";
import { required } from "vuelidate/lib/validators";
import ValidationError from "../../../misc/ValidationError";
import Loader from "../../../../core/Loader";
import Paginator from "../../../../core/Paginator.vue"
const Paperwork = {
    name: "Paperwork",
    components: {
        Loader,
        mdbContainer,
        mdbRow,
        mdbCol,
        mdbCardBody,
        mdbCard,
        Btn,
        Popup,
        ValidationError,
        Paginator
    },
    data() {
        return {
            search: '',
            isLoading: true,
            totalOfElements: 0,
            page: 1,
            perPage: 10,
            numberOfPages: 0,
            dataList: [],
            classPop: "popup__header-admin",
            isEdit: false,
            paperworkName: "",
            clonePaperworkName: "",
            paperworkDescription: "",
            paperworkId: "",
            columns: [
                {
                    label: 'Tipo de trámite',
                    key: 'proceedingTypeValue',
                    sort: false,
                    class: 'text-left',
                    thStyle: {
                        "font-size": "1.6rem",
                        "padding": "1.0rem 0.5rem",
                        "background-color": "#3a8a65",
                        "color": "#fff",
                        "border-top-left-radius": "5px",
                        "border-bottom-left-radius": "5px"
                    },
                    tdClass: "tableCol-start",
                    tdStyle: {
                        "font-size": "1.6rem",
                    }
                },
                {
                    label: 'Descripción',
                    key: 'description',
                    sort: false,
                    class: 'text-left',
                    thStyle: {
                        "font-size": "1.6rem",
                        "padding": "1.0rem 0.5rem",
                        "background-color": "#3a8a65",
                        "color": "#fff"
                    },
                    tdClass: "tableCol",
                    tdStyle: {
                        "font-size": "1.6rem",
                    }
                },
                {
                    label: '', 
                    key: 'options', 
                    sort: false, 
                    class: 'text-center', 
                    thStyle: {
                        "font-size": "1.6rem",
                        "padding": "1.0rem 2.5rem",
                        "background-color": "#3a8a65",
                        "color": "#fff"
                    },
                    tdClass: "tableCol",
                    tdStyle: {
                        "font-size": "1.6rem",
                    }
                },
            ],
        };
    },
    validations: {
        paperworkName: {
            required
        },
        paperworkDescription: {
            required
        },
    },
    methods: {
        ...mapActions([
            "_createPaperwork",
            "_updatePaperwork",
            "_deletePaperwork",
            "_getPaperwork",
        ]),
        cleanData() {
            this.totalOfElements = 0;
            this.page = 1;
            this.perPage = 10;
            this.numberOfPages = 0;
            this.search = "";
            this.dataList = [];
        },
        async getPaperwork() {
            try {
                this.isLoading = true;
                const params = {
                    pageSize: this.perPage,
                    pageNumber: this.page - 1,
                    proceedingType: this.search
                };
                const { data } = await this._getPaperwork(params);
                if (data.status === 200) {
                    const { data: paperwork, totalElements, totalPages } = data;
                    this.numberOfPages = totalPages;
                    this.totalOfElements = totalElements;
                    this.dataList = paperwork;
                }else{
                    this.pushNotifyError();
                }
            }
            catch (error) {
                if (error && error.response && error.response.status === 404) {
                    this.dataList = [];
                } else {
                    this.pushNotifyError();
                }
            }
            finally {
                this.isLoading = false;
            }
        },
        async deletePaperwork() {
            try {
                this.closeModal('delete');
                this.isLoading = true;
                const { data } = await this._deletePaperwork({
                    paperworkId: this.paperworkId
                });
                if (data.status === 200) {
                    this.cleanData();
                    this.getPaperwork();
                    this.alertSuccess(
                        'ELIMINACIÓN CORRECTA',
                        'Trámite eliminado correctamente.'
                    );
                }else{
                    this.pushNotifyError();
                }
            }
            catch (error) {
                this.pushNotifyError();
            }
            finally {
                this.isLoading = false;
            }
        },
        async createPaperwork() {
            try {
                this.$v.$touch();
                if (this.$v.$invalid) {
                    return;
                }
                this.closeModal('persist');
                this.isLoading = true;
                const body = {
                    description: this.paperworkDescription,
                    proceedingTypeValue: this.paperworkName,
                };
                const { data } = await this._createPaperwork(body);
                if (data.status === 201) {
                    this.cleanData();
                    this.getPaperwork();
                    this.alertSuccess(
                        'REGISTRO CORRECTO',
                        'Registro de trámite realizado correctamente.'
                    );
                }
                else{
                    this.pushNotifyError();
                }
            }
            catch (error) {
                if (error && error.response && error.response.data &&  error.response.data.errorDetails) {
                    this.pushNotifyError(error.response.data.errorDetails);
                } else {
                    this.pushNotifyError();
                }
            }
            finally {
                this.isLoading = false;
            }
        },
        async updatePaperwork() {
            try {
                this.$v.$touch();
                if (this.$v.$invalid) {
                    return;
                }
                this.closeModal('persist');
                this.isLoading = true;
                const params = {
                    paperworkId: this.paperworkId,
                    body: {
                        description: this.paperworkDescription,
                    }
                };

                if (this.clonePaperworkName !== this.paperworkName) {
                    Object.assign(params.body, {proceedingTypeValue: this.paperworkName})
                }

                const { data } = await this._updatePaperwork(params);
                if (data.status === 200) {
                    this.cleanData();
                    this.getPaperwork();
                    this.alertSuccess(
                        'EDICIÓN CORRECTA',
                        'Edición de trámite realizada correctamente.'
                    );
                }else{
                    this.pushNotifyError();
                }
            }
            catch (error) {
                if (error && error.response && error.response.data &&  error.response.data.errorDetails) {
                    this.pushNotifyError(error.response.data.errorDetails);
                } else {
                    this.pushNotifyError();
                }
            }
            finally {
                this.isLoading = false;
            }
        },
        closeModal(modal) {
            this.isEdit = false;
            if (modal === 'delete'){
                this.$refs.deleteModal.toggleModal();
            } else {
                this.$refs.persistModal.toggleModal();
            }
        },
        openCreateSellerModal(){
            this.isEdit = false;
            this.paperworkId = "";
            this.paperworkName = "";
            this.paperworkDescription = "";
            this.$refs.persistModal.toggleModal();
        },
        openEditModal({id, paperworkName, paperworkDescription}) {
            this.isEdit = true;
            this.paperworkId = id;
            this.paperworkName = paperworkName;
            this.clonePaperworkName = paperworkName;
            this.paperworkDescription = paperworkDescription;
            this.$refs.persistModal.toggleModal();
        },
        openDeleteModal(id){
            this.paperworkId = id;
            this.$refs.deleteModal.toggleModal();
        },
        pushNotifyError(message = "Ha ocurrido un error, inténtalo más tarde."){
            this.$notify.error({
                message,
                position: "top right",
                timeOut: 15000
            });
        },
        alertSuccess(title, message) {
            Swal.fire({
                title:
                    `<span style='font-family: Josefin Sans,serif; font-size: 22px; font-weight: 600; color: #828282; font-stretch: normal; font-style: normal; line-height: normal;letter-spacing: normal;' >${title} </span>`,
                html:
                    "<div>" +
                    `<span class='mt-4'  style='font-family: Open Sans; font-size: 14px; color: #828282; font-weight: normal'>${message}</span>` +
                    "<br>"+
                    "<img alt='success_icon' src='/img/icons/ok.svg' style='width: 40%; margin-top: 3rem;' />" +
                    "</div>",
                width: "50rem",
                padding: "4rem",
                showConfirmButton: false,
                showCloseButton: true
            });
        },
        changePage(value) {
            this.page = value
        },
        changePerPage(value) {
            this.perPage = value
        },
    },
    mounted() {
        this.cleanData();
        this.getPaperwork();
    },
    watch: {
        search(){
            this.getPaperwork();
        },
        page(){
            this.getPaperwork();
        },
        perPage() {
            this.getPaperwork();
        },
    },
};

export default Paperwork;